// Shows a pin on the map on search results.
import React from 'react';
import { useSelector } from 'react-redux';

import { Marker } from '@react-google-maps/api';

import { getDefaultMarkerPosition } from '@selectors/map-selector';

const SearchMarker = () => {
  const defaultMarkerPosition = useSelector(getDefaultMarkerPosition);
  if (defaultMarkerPosition) {
    return <Marker position={defaultMarkerPosition} />;
  }
  return null;
};

export default SearchMarker;
